<div class="not-found">
    <section class="not-found-description">
        <h1>¡Lo sentimos!</h1>
        <h3 class="sub">El sistema no se encuentra disponible.</h3>
        <p>Nuestro equipo esta trabajando para brindarle una pronta solución.</p>
        <a class="btn btn-primary" href="/panel">Regresar al inicio</a>
    </section>
    <img src="assets/images/Error.svg" alt="Página no encontrada" />
</div>